export const MIAOZI_GTM_ID =
  process.env.NEXT_PUBLIC_GTM_ID?.trim() || 'GTM-5TPDKH6R'

export const GOOGLE_CONSENT_RESTRICTED_REGIONS = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'GB',
  'CH'
] as const
